<template>
  <div class="upgrade-dialog"></div>
</template>
<script>
import { MessageBox } from "element-ui";
import { Dialog } from "vant";
import { getPlatform } from "@tencentcloud/universal-api";
// 导入轮询管理器和错误处理器
import { startVersionCheck } from '@/utils/worker/manager';
export default {
  data() {
    return {
      isPC: getPlatform() === "pc",
      versionUnsub: null
    };
  },
  mounted() {
    this.checkUpgrade();
  },
  beforeDestroy() {
    if(this.versionUnsub) {
      this.versionUnsub();
      this.versionUnsub = null
    }
  },
  methods: {
    checkUpgrade() {
      console.log(
        "当前版本",
        process.env.VUE_APP_ENV,
        process.env.VUE_APP_BUILD_TIME_VERSION
      );
      if (process.env.VUE_APP_ENV != "development") {
        const docUrl = window.location.origin + window.location.pathname;
        const url = (docUrl.endsWith('/') ? docUrl : docUrl + '/') + 'version.json';
        this.versionUnsub = startVersionCheck({
          url,
          version: process.env.VUE_APP_BUILD_TIME_VERSION,
          interval: 10000
        }, (err, data) => {
          if (data?.newVersion) {
            this.openUpgrade(data?.newVersion, data?.oldVersion);
          }
        })
      } else {
        // this.openUpgrade();
      }
    },
    openUpgrade(newVersion, oldVersion) {
      const content = "检测到有新版本更新，请重新刷新页面后使用";
      const confirmButtonText = "刷新页面";
      this.$tracker.send({
        message: '#版本升级提醒#',
        content: {
          newVersion, oldVersion
        },
      })
      const callback = () => {
        window.location.reload();
      };
      const h = this.$createElement;
      this.isPC
        ? MessageBox({
            confirmButtonText,
            confirmButtonClass: "upgrade-dialog-pc-btn",
            showClose: false,
            customClass: "upgrade-dialog-pc",
            closeOnPressEscape: false,
            closeOnClickModal: false,
            message: h("div", [
              h(
                "div",
                {
                  style:
                    "margin-top:5px;display:flex;align-items:center;font-size: 16px;font-weight: 600;",
                },
                [
                  h("i", {
                    class: "el-icon-warning-outline",
                    style: "margin-right:3px;color: #14A0E6;font-size: 20px;",
                  }),
                  "提示",
                ]
              ),
              h(
                "div",
                {
                  style:
                    "background: #EFEFEF;height:1px;margin: 17px 0 24px 0;",
                },
                ""
              ),
              h(
                "div",
                {
                  style:
                    "font-size: 14px;line-height: 22px;color: #333333;font-weight: 400;margin-bottom: 14px;",
                },
                content
              ),
            ]),
          }).then(callback)
        : Dialog.alert({
            title: "温馨提示",
            message: content,
            confirmButtonText,
            confirmButtonColor: "#14A0E6",
            showClose: false,
            className: "upgrade-dialog-h5",
          }).then(callback);
    },
  },
};
</script>
<style lang="scss">
.upgrade-dialog-h5 {
  width: 270px !important;
  .van-dialog__header {
    font-size: 17px;
  }
  .van-dialog__content {
    padding: 0 13px;
  }
  .van-dialog__message {
    font-size: 15px;
    line-height: 22px;
    padding-top: 11px;
    padding-bottom: 18px;
  }
}
.upgrade-dialog-pc {
  width: 500px !important;
  padding-bottom: 16px !important;
  border-radius: 10px !important;
  &-btn {
    background: #14A0E6 !important;
    color: #fff !important;
    border-radius: 20px !important;
    padding: 0 20px !important;
    height: 36px !important;
    line-height: 20px !important;
    font-size: 14px !important;
    font-weight: 600 !important;
  }
}
</style>
